<template>
    <div>
        <template v-if="controlStatus === 2">
            <div class="no-video">开标已结束！</div>
        </template>
        <template v-else>
            <div class='video'>
            </div>
            <div class='videoBtns'>
                <el-row :gutter="10">
                    <!-- <el-col :span="12" v-if='role=="T"||role=="A"'>
                        <button
                        type='button' 
                        :disabled='!controlButton'
                        :class='[!controlButton?"disabled":""]'
                        @click='changeStates'
                        >{{controlStatus==1?'关闭直播通道':'开启直播通道'}}
                        </button>
                    </el-col> -->
                    <!-- <el-col :span='role=="T"||role=="A"?12:24' > -->
                    <el-col :span='24' >
                        <button
                        type='button' 
                        @click='openUrl'
                        :disabled='btns.length==0'
                        :class='[btns.length==0?"disabled":""]'
                        >观看直播
                        </button>
                    </el-col>
                </el-row>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    name:'myVideo',
    components:{
    },
    props:{
        bdId:{
            type:String
        }
    },

    computed:{
        role() {
            return localStorage.getItem("role") ? localStorage.getItem("role") : "T";
        },
	},
    data(){
        return{
            btns:[],
            controlButton:false,
            controlStatus:1,

        }
    },
    methods:{
        openUrl() {
            let routeUrl = this.$router.resolve({
                path: 'sxt',// 这里的路径就可以正常的写，不需要添加_blank: true
                query:{
                    bdId:this.bdId
                }
            })
            window.open(routeUrl.href, '_blank')
        },
		//获取摄像头参数
        getSxt(){
			let para={}
            this.$api.getSxt(para).then(res=>{
                if(res.data.meta.success){
                    this.controlButton=res.data.data.controlButton;
                    this.controlStatus=res.data.data.controlStatus;
                    if(res.data.data.sxtdz){
                        this.cdbm=res.data.data.cdbm;
                        let sxtdz = res.data.data.sxtdz.split(',')
                        this.btns=[{text:'主持人桌面',url:sxtdz[0]}];
                        this.changeVideo(sxtdz[0])
                        sxtdz.forEach((item,index)=>{
                            if(index != 0){
                                let i=index
                                this.btns.push({text:'摄像头'+i,url:item})
                            }
                        })
                    }else{
                        this.btns=[]
                    }

				}
            }).catch(()=>{})
        },
         changeStates(){
            // let para={
            //     controlStatus:this.controlStatus==1?2:1,
            //     bdId:this.bdId
            // }
            // this.$api.controlVideo(para).then(res=>{
            //     if(res.data.meta.success){
            //         if(this.controlStatus==2){
            //             this.$message.success('直播已开启，可以查看现场监控画面')
            //         }
            //         this.getSxt()
			// 	}else{

            //     }
            // }).catch(()=>{})
        },
        closeVideo(){
            this.controlStatus = 2
        },

    },
    mounted(){
        this.getSxt();
    }, 
    destroyed(){}     
}
</script>
<style lang="less" scoped>
.video-dimensions{
    overflow: hidden;
    width:458px;
    height:270px;
    video{
        width: 100%;
        height:100%;
    }
}
    .video{
        width: 100%;
        height:270px;
        background: #333;
        position: relative;
        #f_ocx{
            position:absolute;
            top:0;
            left:0;
            width:100%;
            height:100%;
            visibility: hidden;
            background:#333;
        }
        #f_ocx.active{
            visibility: initial;
        }
        #f_ocx2.active{
            visibility: initial;
        }
    }
    .videoBtns{
        padding:10px 0;
        button{
            height:45px;
            line-height:45px;
            background:#0060b2;
            color:#fff;
            font-size: 16px;
            width: 100%;
            &.disabled{
                cursor: not-allowed;
                background:#404040;
            }

        }
    }

.no-video {
    width: 100%;
    height: 325px;
    margin-bottom: 10px;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
}
</style>